export default __webpack_public_path__ + "static/media/header_settings.7597dd0c.svg";